import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from '../../components/input/input';
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import theme from '../../theme';
import React, { useState } from 'react';
import { cmxErrors } from '@codametrix/ui-common';
const { getFieldErrorMessage } = cmxErrors;
const UpdatePasswordForm = (props)=>{
    const { handleNewPassword, error, submitting, includeOldPassword, formErrors } = props;
    const [existingPassword, changeOldPassword] = useState('');
    const [newPassword, changeNewPassword] = useState('');
    const [newPasswordConfirm, changeNewPasswordConfirm] = useState('');
    const newPasswordErrorMessage = getFieldErrorMessage(formErrors, [
        'newPassword',
        'password'
    ]);
    const newPasswordConfirmErrorMessage = getFieldErrorMessage(formErrors, [
        'newPasswordConfirm',
        'confirmPassword'
    ]);
    const existingPasswordErrorMessage = getFieldErrorMessage(formErrors, [
        'existingPassword'
    ]);
    const submitEnabled = (existingPassword.length || !includeOldPassword) && newPassword.length && newPasswordConfirm.length ? false : true;
    const handleSubmit = (event)=>{
        event.preventDefault();
        const passwordData = {
            existingPassword,
            newPassword,
            newPasswordConfirm
        };
        handleNewPassword(passwordData);
    };
    return /*#__PURE__*/ _jsx("form", {
        className: "password-change-form",
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ _jsxs("fieldset", {
            disabled: submitting,
            children: [
                error && /*#__PURE__*/ _jsxs("div", {
                    className: "error-msg",
                    children: [
                        /*#__PURE__*/ _jsx("i", {
                            className: "fa fa-times-circle"
                        }),
                        "  There was an issue changing your password. Please check that your input is correct."
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "form-group",
                    children: [
                        includeOldPassword ? /*#__PURE__*/ _jsxs("div", {
                            className: "form-row",
                            children: [
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "form-label",
                                    htmlFor: "input-email-1",
                                    children: [
                                        "Current Password",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "required-indicator",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Input, {
                                    autoFocus: true,
                                    onChange: (e)=>{
                                        changeOldPassword(e.target.value);
                                    },
                                    name: 'existingPassword',
                                    placeholder: '',
                                    type: 'password',
                                    className: error ? 'form-input is-error' : 'form-input'
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: 'error-text',
                                    children: existingPasswordErrorMessage
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ _jsxs("div", {
                            className: "form-row",
                            children: [
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "form-label",
                                    htmlFor: "input-email-1",
                                    children: [
                                        "New Password",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "required-indicator",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Input, {
                                    autoFocus: true,
                                    onChange: (e)=>{
                                        changeNewPassword(e.target.value);
                                    },
                                    name: 'newPassword',
                                    placeholder: '',
                                    type: 'password',
                                    className: error ? 'form-input is-error' : 'form-input'
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: 'error-text',
                                    children: newPasswordErrorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "form-row",
                            children: [
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "form-label",
                                    htmlFor: "input-email-1",
                                    children: [
                                        "Confirm New Password",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "required-indicator",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Input, {
                                    autoFocus: true,
                                    onChange: (e)=>{
                                        changeNewPasswordConfirm(e.target.value);
                                    },
                                    name: 'newPasswordConfirm',
                                    placeholder: '',
                                    type: 'password',
                                    className: error ? 'form-input is-error' : 'form-input'
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: 'error-text',
                                    children: newPasswordConfirmErrorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "form-row",
                            children: /*#__PURE__*/ _jsx(Button, {
                                size: ButtonSize.MD,
                                disabled: submitEnabled,
                                label: 'Submit',
                                backgroundColor: theme.colors.accent[100],
                                className: "qa-submit-password-button",
                                color: theme.colors.text['light'],
                                type: "submit"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
export default UpdatePasswordForm;
